import { useQuery } from "react-query";
import { PRODUCTS } from "../constants";
import { getProductsList } from "./ReplenishServices";

const useGetProducts = () => {
  return useQuery(PRODUCTS, () => getProductsList());
};

export default useGetProducts;
